export default __webpack_public_path__ + "static/media/pix-white.cacd53bf.svg";